import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type LocationRecord = QueryAtomResult<
  typeof queryLocationListAtom
>[number];

export const queryLocationListAtom = createQueryAtomFactory(
  'settings.locationList',
  (params: { searchTerm?: string }) => ({
    facilities: {
      __args: {
        filter: {
          ...(params.searchTerm ? { searchTerm: params.searchTerm } : {}),
        },
        pagination: {
          offset: 0,
          limit: 300,
        },
      },
      entries: {
        id: true,
        address: {
          streetAddress: true,
          city: true,
          state: true,
          country: true,
          postalCode: true,
        },
        facilityName: true,
        facilityType: true,
        timezone: true,
        facilityGroup: {
          id: true,
          name: true,
        },
      },
    },
  }),
  {
    select: (data) =>
      data?.facilities.entries.map((location) => ({
        id: location.id,
        name: location.facilityName,
        address: location.address
          ? {
              streetAddress: location.address.streetAddress,
              city: location.address.city,
              state: location.address.state,
              country: location.address.country,
              postalCode: location.address.postalCode,
            }
          : undefined,
        type: location.facilityType,
        timezone: location.timezone,
        // phone: location.phone,
        // email: location.email,
        facilityGroup: location.facilityGroup
          ? {
              id: location.facilityGroup.id,
              name: location.facilityGroup.name,
            }
          : undefined,
      })) ?? [],
  },
);
